module.exports = __webpack_public_path__ + "src/assets/img/m7.bcab4fb8.jpg";